const binding = { modules: {}, dataActions: {} };

    (binding.modules['celli-business-sign-up'] = {
        c: () => require('partner/modules/celli-business-sign-up/celli-business-sign-up.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'celli-business-sign-up',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/celli-business-sign-up'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|celli-business-sign-up|celli-business-sign-up'] = {
                c: () => require('partner/modules/celli-business-sign-up/celli-business-sign-up.view.tsx'),
                cn: '__local__-__local__-celli-business-sign-up'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };